const initialState = {
  rentalPark: [],
  totalElements: 0,
  loading: false,
  showModal: false
};

export function fetchRentalPark(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.RENTAL_PARK.SUCCESS':
      return {
        ...state,
        rentalPark: action.rentalPark.body.content,
        totalElements: action.rentalPark.body.totalElements
      };
    case 'SHOW.RENTING_JOURNEY_MODAL':
      return {
        ...state,
        showModal: action.params.show,
        rentalDetails: action.params.rentalDetails,
      };
    case 'SHOW.MANUAL_RENTAL_BOOKING_MODAL':
      return {
        ...state,
        showManualRentalBookingModal: action.params.show,
        rentalDetails: action.params.rentalDetails,
      };
    default:
      return state
  }
}

export function fetchInterventionRentalPark(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.INTERVENTION_RENTAL_PARK.SUCCESS':
      return {
        ...state,
        rentalPark: action.rentalPark.body.planning.content,
        totalElements: action.rentalPark.body.planning.totalElements
      };
    default:
      return state
  }
}
